import { Injectable ,Inject, PLATFORM_ID} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router, } from '@angular/router';
import { ToastrService } from 'src/app/services/toastr.service';
import { MessageService } from './message.service';
import { isPlatformBrowser, Location } from '@angular/common';

 

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	isBrowser:boolean;
    constructor(
		private router:Router, 
		public toastr : ToastrService,
		private messageService: MessageService,
		@Inject(PLATFORM_ID) platformId: Object,
		private _location: Location) {
			this.isBrowser = isPlatformBrowser(platformId);
		 }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {		
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401 && typeof localStorage !== 'undefined') {
				
				localStorage.removeItem('authUser');
				localStorage.removeItem('profile_img_url')
				localStorage.removeItem('login_token')
				localStorage.removeItem('cart_details');
				localStorage.removeItem('gift_box_details');
				this.toastr.errorToastr('Your session has expired please login again. ', 'Error!');
				// localStorage.removeItem('accepted')
				setTimeout(() => {
					if(this.isBrowser){

						if (typeof window !== 'undefined') {
							window.location.href = '/login'
						}
					}
				}, 1000);

                const error = err.error.message || err.statusText;
                return throwError(error);
            }else{
            //this.toastr.errorToastr('Please check your internet connection and try again. ', 'Error!');
				//console.log("called interceptor")
				const error = err.error.message || err.statusText;
				return throwError(error);
			}
        }))
    }
}